<mat-form-field subscriptSizing="dynamic"
                class="st-date-time-picker-date"
                [matTooltip]="label">
    <mat-label class="st-date-time-picker-label"
               *ngIf="label">{{label}}</mat-label>
    <input matInput
           #input
           [matDatepicker]="picker"
           [readonly]="disabled"
           [placeholder]="placeholder"
           (dateChange)="dateChange($event)"
           [required]="required"
           [min]="minDate"
           [formControl]="internalFormControl" />
    <mat-datepicker-toggle matIconSuffix
                           (click)="picker.open()"
                           [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker
                    (closed)="input.blur()"
                    (opened)="getDatePicker(picker)"
                    panelClass="st-date-time-picker-calendar"
                    (monthSelected)="getDatePicker(picker)"
                    [disabled]="disabled">
        <mat-datepicker-actions>
            <button mat-button
                    matDatepickerCancel
                    (click)="clearDate()">
                {{languageSettings.PSTWebDatePickerClearLabel}}
            </button>
        </mat-datepicker-actions>
    </mat-datepicker>
    <ng-container *ngIf="hasSuffix"
                  matSuffix>
        <ng-content select="[suffix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasPrefix"
                  matPrefix>
        <ng-content select="[prefix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasError"
                  matError>
        <ng-content select="[error]"></ng-content>
    </ng-container>
</mat-form-field>
<time-control class="st-date-time-picker-time"
              [value]="dateValue"
              [disabled]="disabled"
              [required]="required"
              [label]="languageSettings.PSTWebTimeLabel"
              (changed)="timeChanged($event)"></time-control>
<combo-box class="st-date-time-picker-timezone"
           [placeholder]="languageSettings.PSTWebTimeZoneLabel"
           [label]="languageSettings.PSTWebTimeZoneLabel"
           *ngIf="showTimeZone"
           [itemList]="commonTimeZones"
           [disabled]="disabled"
           [additionalItemList]="ianaTimeZones"
           [value]="getTimeZone()"
           (changed)="timezoneChanged($event)"></combo-box>
